/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    base: '0em',
    xxxs: '23.45em', // 375px
    xxs: '24.53em', // 393px
    xs: '25em', // 400px
    sm: '30em', // 480px
    md: '48em', // 768px
    '2md': '51em', // 816px
    lg: '62em', // 992px,
    '2lg': '68.75em', // 1100px
    '3lg': '75em', // 1200px
    xl: '80em', // 1280px
    'xl-large': '83.5em', // 1336px
    '2xl': '96em', // 1536px
    '3xl': '120em' // 1920px
}
